import { inject, Pipe, PipeTransform } from '@angular/core';
import * as i18nIsoCountries from 'i18n-iso-countries';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'countryTranslation',
  standalone: true,
})
export class CountryTranslationPipe implements PipeTransform {
  countriesIso = i18nIsoCountries;
  translocoService = inject(TranslocoService);
  language = this.translocoService.getActiveLang().split('-')[0];

  transform(countryCode?: string): string {
    return countryCode ? this.countriesIso.getName(countryCode, this.language) + ' (' + countryCode + ')' : '';
  }
}
